var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 369,
    viewBox: "0 0 311 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 352.101V353.309L0.549627 353.259C1.14829 361.801 8.26781 368.535 16.9554 368.5L211.113 367.763C221.213 367.727 230.927 363.841 238.269 356.896L297.327 301.063C305.732 293.117 310.5 282.052 310.5 270.474V1V0.5H310H62.0369C54.4291 0.5 47.1015 3.41792 41.5696 8.64833C41.5696 8.64833 41.5696 8.64834 41.5696 8.64835L9.80463 38.6786C3.86617 44.2889 0.5 52.1035 0.5 60.2792V352.101Z",
    fill: "white",
    stroke: "#FF0000",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorMain);
export default __webpack_public_path__ + "static/media/VectorMain.b0005e3eae285eea6a00646f0da9b949.svg";
export { ForwardRef as ReactComponent };